/* mm-clip.js — 漫画LPの「動くコマ」（メーカー公式映像の4〜5秒・無音ループ）
   正本: work/lp-clips-20260928/component/mm-clip.js（説明は ../COMPONENT.md）。2026-09-28 作成。依存なし・約2KB（圧縮前）。
   - 動画のファイルは、コマが画面に近づくまで読み込まない（<source data-src> を、600px 手前で src に移す）。
   - コマが50%以上見えている間だけ再生し、外れたら止める。タブが裏に回ったら止める。
   - 動きを減らす設定（prefers-reduced-motion）・データ節約（Save-Data）・IntersectionObserver の無いブラウザでは、静止画（poster）だけ。
   - 操作部（controls）は出さない。動画をタップすると一時停止／再開（WCAG 2.2.2 の「止める手段」）。
   - 初めて再生したとき、figure から 'mmclip:play' のイベント（detail.clip）を出す。LP の計測は window.mmClipPub(clipId) を置けば呼ばれる。
   - Shopify のテーマエディタでセクションが読み直されたとき（shopify:section:load）も、新しいコマを拾う。 */
(function () {
  'use strict';
  var d = document;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var conn = navigator.connection || {};
  var hasIO = 'IntersectionObserver' in window;
  var near = null, vis = null, all = [];

  function still() { return !!((mq && mq.matches) || conn.saveData === true); }

  function setPoster(f) {
    var v = f._v, p = v.getAttribute('data-poster');
    if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
  }
  function arm(f) {
    if (f._armed || still()) return;
    f._armed = true;
    var v = f._v;
    Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) {
      s.setAttribute('src', s.getAttribute('data-src'));
      s.removeAttribute('data-src');
    });
    v.preload = 'auto';
    v.load();
  }
  function mark(f) {
    if (f._seen) return;
    f._seen = true;
    var id = f.getAttribute('data-clip') || '';
    try { f.dispatchEvent(new CustomEvent('mmclip:play', { bubbles: true, detail: { clip: id } })); } catch (e) {}
    if (typeof window.mmClipPub === 'function') { try { window.mmClipPub(id); } catch (e) {} }
  }
  function play(f, byUser) {
    if (!byUser && (f._user || still())) return;
    setPoster(f);
    arm(f);
    var v = f._v;
    v.muted = true;
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    var ok = function () { f.classList.remove('is-blocked'); f.classList.add('is-playing'); mark(f); };
    if (p && typeof p.then === 'function') {
      p.then(ok, function () { f.classList.remove('is-playing'); f.classList.add('is-blocked'); label(f); });
    } else { ok(); }
  }
  function stop(f) {
    var v = f._v;
    if (!v.paused) v.pause();
    f.classList.remove('is-playing');
  }
  function label(f) {
    var b = f._b;
    if (!b) return;
    var stopped = f._user || f.classList.contains('is-blocked');
    b.setAttribute('aria-label', stopped ? '動画を再生' : '動画を一時停止');
    b.setAttribute('aria-pressed', f._user ? 'true' : 'false');
  }
  function toggle(f) {
    if (still()) return;
    var v = f._v;
    if (!v.paused && !f._user) {
      f._user = true; f.classList.add('is-paused'); stop(f);
    } else {
      f._user = false; f.classList.remove('is-paused'); play(f, true);
    }
    label(f);
  }

  function setup(root) {
    var figs = Array.prototype.slice.call((root || d).querySelectorAll('.mm-clip[data-clip]'));
    figs.forEach(function (f) {
      if (f._ready) return;
      var v = f.querySelector('video');
      if (!v) return;
      f._ready = true; f._v = v; v._f = f;
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      f._b = f.querySelector('.mm-clip-tog');
      if (f._b) f._b.addEventListener('click', function (e) { e.preventDefault(); toggle(f); });
      v.addEventListener('click', function () { toggle(f); });
      label(f);
      all.push(f);
      if (still() || !hasIO) {
        f.classList.add('is-still');
        if (!hasIO) setPoster(f);
      }
      if (hasIO) { near.observe(f); vis.observe(v); }
    });
  }

  if (hasIO) {
    near = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var f = e.target;
        setPoster(f);
        arm(f);                       /* 静止画だけのときは arm の中で何もしない */
        near.unobserve(f);
      });
    }, { rootMargin: '600px 0px' });
    vis = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var f = e.target._f;
        if (!f) return;
        f._vis = e.isIntersecting && e.intersectionRatio >= 0.5;
        if (f._vis) play(f); else stop(f);
      });
    }, { threshold: [0, 0.5, 1] });
  }

  d.addEventListener('visibilitychange', function () {
    all.forEach(function (f) { if (d.hidden) stop(f); else if (f._vis) play(f); });
  });
  if (mq) {
    var onChange = function () {
      all.forEach(function (f) {
        f.classList.toggle('is-still', still());
        if (still()) { stop(f); setPoster(f); } else if (f._vis) play(f);
      });
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
  }
  d.addEventListener('shopify:section:load', function (e) { setup(e.target); });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { setup(d); });
  else setup(d);
})();
